import React from 'react';
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import {CircularProgress, Stack} from "@mui/joy";
import Card from "@mui/joy/Card";

// components
import CommonPaginatedTable from "../Common/CommonPaginatedTable";


class FinancialTotals extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            quarters: null,
            total: null,
        }
    }

    async componentDidMount() {
        let quarters = Object.entries(this.props.quarters).map((each) => {
            let quarter = each[1];
            if (this.props.miles) {
                for (let k of Object.keys(quarter)) {
                    quarter[k] = quarter[k] / 1000;
                }
            }
            if (each[0] === 'total') {
                quarter.number = 'Итого';
            } else {
                quarter.number = each[0];
            }
            return quarter
        })
        this.setState(
            {
                quarters: quarters,
                total: this.props.total,
            }
        )
    }

    render() {
        if (!this.state.totals && !this.state.quarters) {
            return (
                <CircularProgress/>
            )
        }
        let numberFormat = new Intl.NumberFormat('ru', {maximumFractionDigits: 2})
        return(
            <Stack>
                <Typography
                    level={'h4'}
                    sx={{
                        mb: 2
                    }}
                >
                   Кварталы
                </Typography>
                <CommonPaginatedTable
                    title={''}
                    data={this.state.quarters}
                    fields={[
                        {
                            title: 'Квартал',
                            name: 'number',
                            visible: true,
                        },
                        {
                            title: 'Выручка (факт)',
                            name: 'revenueFact',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Выручка (прогноз)',
                            name: 'revenueForecast',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Выручка (хвост)',
                            name: 'revenueLeadTail',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Вх. платеж (факт)',
                            name: 'incomeFact',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Вх. платеж (прогноз)',
                            name: 'incomeForecast',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Вх. платеж (хвост)',
                            name: 'incomeLeadTail',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Накладные',
                            name: 'expense',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'ФОТ (сумма)',
                            name: 'salaries',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Баланс (факт)',
                            name: 'balance',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Баланс (прогноз + хвост)',
                            name: 'balanceForecast',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Прибыль (факт)',
                            name: 'profit',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                        {
                            title: 'Прибыль (прогноз + хвост)',
                            name: 'profitForecast',
                            visible: true,
                            preProcess: (value) => (value?numberFormat.format(value):value)
                        },
                    ]}
                />
                <Typography
                    level={'h4'}
                    sx={{
                        mb: 2
                    }}
                >
                   Год
                </Typography>
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        alignItems: "center",
                        mb: 1,
                    }}
                >
                    <Card
                        color="teal"
                        variant="soft"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                                sx={{
                                    color: 'white'
                                }}
                            >
                                Выручка
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'white'
                                }}
                            >
                                {numberFormat.format(this.props.total.revenueFact + this.props.total.revenueForecast /* + this.props.total.revenueLeadTail */)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       =
                    </Typography>
                    <Card
                        color="teal"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Заключенные договоры
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.revenueFact)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       +
                    </Typography>
                    <Card
                        color="teal"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Прогноз
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.revenueForecast)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       +
                    </Typography>
                    <Card
                        color="teal"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Хвост
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.revenueLeadTail)}
                            </Typography>
                        </CardContent>
                    </Card>
                </Stack>
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        alignItems: "center",
                        mb: 1,
                    }}
                >
                    <Card
                        color="success"
                        variant="soft"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Входящие платежи
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.incomeFact + this.props.total.incomeForecast /* + this.props.total.incomeLeadTail */)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       =
                    </Typography>
                    <Card
                        color="success"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Заключенные договоры
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.incomeFact)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       +
                    </Typography>
                    <Card
                        color="success"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Прогноз
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.incomeForecast)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       +
                    </Typography>
                    <Card
                        color="success"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Хвост
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.incomeLeadTail)}
                            </Typography>
                        </CardContent>
                    </Card>
                </Stack>
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        alignItems: "center",
                        mb: 1,
                    }}
                >
                    <Card
                        color="danger"
                        variant="soft"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Траты
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.expense + this.props.total.salaries + this.props.total.tax + this.props.total.taxForecast)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       =
                    </Typography>
                    <Card
                        color="danger"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Накладные расходы
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.expense)} ({numberFormat.format(this.props.total.adminSalaries)})
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       +
                    </Typography>
                    <Card
                        color="danger"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                ФОТ
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.salaries)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       +
                    </Typography>
                    <Card
                        color="danger"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Налог УСН + НДС
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.tax)}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Typography
                        level={'h4'}
                    >
                       +
                    </Typography>
                    <Card
                        color="danger"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                            >
                                Налог УСН + НДС (прогноз)
                            </Typography>
                            <Typography>
                                {numberFormat.format(this.props.total.taxForecast)}
                            </Typography>
                        </CardContent>
                    </Card>
                </Stack>
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        alignItems: "center",
                        mb: 1,
                    }}
                >
                    <Card
                        color="purple"
                        variant="soft"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                                sx={{
                                    color: 'white'
                                }}
                            >
                                Прибыль
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'white'
                                }}
                            >
                                {numberFormat.format(this.props.total.profit)} ({numberFormat.format(this.props.total.profitForecast)})
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card
                        color="purple"
                        variant="soft"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                                sx={{
                                    color: 'white'
                                }}
                            >
                                Прибыль %
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'white'
                                }}
                            >
                                {numberFormat.format(100 * this.props.total.profit / (this.props.total.expense + this.props.total.salaries + this.props.total.tax))}&nbsp;
                                ({numberFormat.format(100 * this.props.total.profitForecast / (this.props.total.expense + this.props.total.salaries + this.props.total.tax + this.props.total.taxForecast))})
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card
                        color="indigo"
                        variant="soft"
                        size={'sm'}
                    >
                        <CardContent>
                            <Typography
                                level={'body-xs'}
                                sx={{
                                    color: 'white'
                                }}
                            >
                                Баланс платежей
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'white'
                                }}
                            >
                                {numberFormat.format(this.props.total.balance)} ({numberFormat.format(this.props.total.balanceForecast)})
                            </Typography>
                        </CardContent>
                    </Card>
                </Stack>
            </Stack>
        )
    }
}

export default FinancialTotals
